import { Controller } from "@hotwired/stimulus"

// Reloads the current list with a new per_page size, resetting to page 1 and
// preserving any active search/filter params. Loads into the turbo-frame named
// by the `frame` value (default "content"); module lists pass their own list
// frame (e.g. "variable_groups_list"). Falls back to a full navigation when no
// matching frame is on the page.
export default class extends Controller {
  static values = { frame: { type: String, default: "content" } }

  change(event) {
    const url = new URL(window.location.href)
    url.searchParams.set("per_page", event.target.value)
    url.searchParams.delete("page")
    // Also reset any section-scoped page params (e.g. variables_page) so a
    // smaller size can't leave a stale page pointing past the new last page.
    // Guard `per_page` itself — it ends in "_page" too, and dropping it here is
    // what made changing the page size silently fall back to the default.
    for (const key of [ ...url.searchParams.keys() ]) {
      if (key !== "per_page" && key.endsWith("_page")) url.searchParams.delete(key)
    }

    const frame = this.element.closest("turbo-frame") || document.getElementById(this.frameValue)
    if (!frame) {
      window.location.assign(url.toString())
      return
    }

    // Drive a real Turbo frame link instead of assigning frame.src directly, so
    // the URL advances (history + the per_page param persist). A bare src change
    // would load the rows but leave the address bar — and the selector state —
    // out of sync.
    const link = document.createElement("a")
    link.href = url.toString()
    link.setAttribute("data-turbo-frame", frame.id)
    link.setAttribute("data-turbo-action", "advance")
    link.hidden = true
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}
